export default __webpack_public_path__ + "static/media/Kitty 9781408327944.f904a060.jpg";